import { registrationRequested, registrationCompleted, projectPage } from "./sessions.js";

import { 
  investmentAtPersonalInfoStep, investmentAtQuestionnaireStep,
  investmentAtPaymentMethodStep, investmentAtConfirmationStep,
  investmentSuccessfullyCreated
} from "./investments.js";

import {
  NewsletterSourceRegistration, NewsletterSourceMainPage,
  subscribedToNewsletter
} from "./newsletter.js";

const Analytics = {
  registrationRequested,
  registrationCompleted,

  investmentAtPersonalInfoStep,
  investmentAtQuestionnaireStep,
  investmentAtPaymentMethodStep, 
  investmentAtConfirmationStep,
  investmentSuccessfullyCreated,

  subscribedToNewsletter,
  projectPage
}

export default Analytics;
export { NewsletterSourceRegistration, NewsletterSourceMainPage };